import React from "react";
import { Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

import { selectSelectedTeam } from "../../../features/clubhouse/clubhouseSlice";
import { selectSetting } from "../../../features/global/globalSlice";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { Breakpoint } from "../../../hooks/useBreakpoint";
import { AUTH_LEVELS } from "../../../lib/globals";

const ClubhouseSidebar = ({
    breakpoint,
    toggleNavbar,
}: {
    breakpoint: Breakpoint;
    toggleNavbar: () => void;
}): React.JSX.Element => {
    const selectedTeam = useAppSelector(selectSelectedTeam);
    const currentYear = parseInt(
        useAppSelector(state =>
            selectSetting(state, "majorybl_current_league_year"),
        )?.setting,
    );
    const { user } = useAppSelector(state => state.auth);
    const routePrefix = `/coachs-clubhouse/team/${selectedTeam?.id}`;
    let setting = useAppSelector(state =>
        selectSetting(state, "majorybl_display_placement_link"),
    );
    const displayPlacement = Boolean(setting?.setting === "true" ? 1 : 0);

    setting = useAppSelector(state =>
        selectSetting(state, "majorybl_display_resume_link"),
    );
    const displayResume = Boolean(setting?.setting === "true" ? 1 : 0);
    const currentTeamsLeague = selectedTeam?.leagues?.find(
        l => l.year === currentYear,
    );

    const buttonConfig = [
        {
            to: `${routePrefix}/league-info`,
            text: "Opp. Team's Info",
            condition: !!currentTeamsLeague,
        },
        {
            to: `${routePrefix}/schedule`,
            text: "Team Schedule",
            condition: !!currentTeamsLeague,
        },
        {
            to: `${routePrefix}/league/${currentTeamsLeague?.id}`,
            text: "League Standings",
            condition: !!currentTeamsLeague,
        },
        {
            to: `${routePrefix}/league/${currentTeamsLeague?.id}/schedule`,
            text: "League Schedule",
            condition: !!currentTeamsLeague,
        },
        {
            to: `${routePrefix}/league/${currentTeamsLeague?.id}/playoffs`,
            text: "League Playoff Bracket",
            condition: !!currentTeamsLeague,
        },
        {
            to: `${routePrefix}/roster`,
            text: "Roster",
            condition: true,
        },
        {
            to: `${routePrefix}/coi`,
            text: "Cert. of Insurance",
            condition: true,
        },
        {
            to: `${routePrefix}/policy-procedures`,
            text: "Policy & Procedures",
            condition: true,
        },
        {
            to: `${routePrefix}/rules`,
            text: "League Rules",
            condition: true,
        },
        {
            to: `${routePrefix}/tryouts`,
            text: "Tryout Info",
            condition: true,
        },
        {
            to: `${routePrefix}/looking-for-players`,
            text: "Looking for Players",
            condition: true,
        },
        {
            to: `${routePrefix}/resume`,
            text: "Team Resume",
            condition:
                selectedTeam?.settings?.showResumeToCoach ||
                (displayResume && !selectedTeam?.settings?.hideResumeFromCoach),
        },
        {
            to: `${routePrefix}/placement`,
            text: "Team Placement",
            condition: displayPlacement,
        },
        {
            to: `${routePrefix}/ratings`,
            text: "Team Ratings",
            condition:
                user && AUTH_LEVELS.leaguemanagement.includes(user.userLevel),
        },
    ];

    const visibleButtons = buttonConfig
        .filter(button => button.condition)
        .sort((a, b) => a.text.localeCompare(b.text));

    return (
        <Stack gap={2}>
            <Link
                to={`${routePrefix}`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Team Home
            </Link>
            {visibleButtons.map((button, index) => (
                <Link
                    key={index}
                    to={button.to}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    {button.text}
                </Link>
            ))}
        </Stack>
    );
};

export default ClubhouseSidebar;
